import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";

const UNCapacityBuildingContent = () => {
  const facilities = [
    { name: "Fasilitas Kantor dan Administrasi", icon: "🏢" },
    { name: "Akomodasi (kamar dan Barak Poki dan Polwan)", icon: "🏠" },
    { name: "Ruang kelas", icon: "🎓" },
    { name: "Command Center", icon: "💻" },
    { name: "Garuda Hall", icon: "🦅" },
    { name: "VIP Transit Room", icon: "✈️" },
    {
      name: "Gudang (Gudang Senjata dan Amunisi, Gudang Logistik)",
      icon: "📦",
    },
    { name: "Ruang Makan", icon: "🍽️" },
    { name: "Lapangan", icon: "⚽" },
    { name: "Klinik", icon: "🏥" },
    { name: "Garasi", icon: "🚗" },
    { name: "Ruang Workshop Mekanik", icon: "🔧" },
  ];

  const purposes = [
    "Memastikan kesiapan personel dan peralatan untuk mengikuti misi internasional secara profesional dan efektif.",
    "Mengelola administrasi, logistik, dan pelaporan terkait penugasan internasional.",
    "Melaksanakan pelatihan dan pengembangan kapasitas personel agar mampu menjalankan tugas di tingkat internasional dengan standar tinggi.",
    "Menjalin hubungan kerja sama yang erat dengan lembaga penegak hukum internasional dan negara mitra.",
    "Mendukung diplomasi keamanan melalui kerjasama dan pertukaran informasi.",
    "Mendukung posisi Indonesia di forum internasional melalui partisipasi aktif dalam berbagai misi dan kegiatan internasional.",
  ];

  const functions = [
    "Mengembangkan jaringan dan bertindak sebagai pusat pelatihan (Regional Training Hub) untuk negara-negara terdekat dalam konteks pemeliharaan perdamaian dan praktik kepolisian lainnya",
    "Mengembangkan materi pelatihan dan praktik terbaik dalam pemeliharaan perdamaian berdasarkan Pedoman PBB",
    "Melaksanakan Program Pelatihan Pra-Penugasan untuk para peacekeeper Polri (FPU & IPO)",
    "Melaksanakan pelatihan untuk Atase Kepolisian dan Kandidat Staf Teknis Kepolisian",
    "Melaksanakan Pelatihan Personal Security Awareness Training untuk Kandidat Staf Diplomatik Indonesia",
  ];

  const internationalContributions = [
    {
      title: "Partisipasi dalam Interpol",
      description:
        "Polri aktif sebagai anggota Interpol, berperan dalam pertukaran informasi intelijen, penangkapan buronan internasional, serta penanggulangan kejahatan transnasional seperti narkoba, perdagangan manusia, dan terorisme.",
      icon: "🌐",
    },
    {
      title: "Misi Pemeliharaan Perdamaian PBB",
      description:
        "Polri turut serta dalam misi perdamaian PBB dengan mengirimkan Satgas Garuda Bhayangkara untuk membantu tugas keamanan dan ketertiban di berbagai negara (FPU, IPO dan P-Post).",
      icon: "🕊️",
    },
    {
      title: "Penanggulangan Terorisme",
      description:
        "Aktif dalam forum internasional seperti ASEANAPOL, ASEAN Chiefs of Police, untuk memperkuat kerja sama dalam pencegahan dan penanganan terorisme serta kejahatan lintas negara.",
      icon: "🛡️",
    },
    {
      title: "Pelatihan dan Pengembangan",
      description:
        "Mengirimkan personel untuk pelatihan internasional dan menjadi fasilitator pelatihan bagi aparat penegak hukum dari negara lain.",
      icon: "📚",
    },
    {
      title: "Kerja Sama Regional",
      description:
        "Aktif dalam forum regional seperti ASEANAPOL dan East Asia Summit, fokus pada kerjasama keamanan dan penegakan hukum di kawasan Asia Timur dan Asia Tenggara.",
      icon: "🤝",
    },
  ];

  const OverviewContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* Introduction */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            UN Capacity Building Program
          </h2>
          <p className="leading-relaxed text-base-content/70 mb-4">
            Program pengembangan kapasitas PBB yang dilaksanakan oleh Polri
            merupakan bagian integral dari komitmen Indonesia dalam mendukung
            misi pemeliharaan perdamaian internasional. Program ini mencakup
            pengembangan kemampuan pelatihan, sertifikasi internasional, dan
            kerjasama regional.
          </p>
          <p className="leading-relaxed text-base-content/70">
            Pusat Misi Internasional Polri berperan sebagai Regional Training
            Hub yang mendukung pengembangan kapasitas tidak hanya untuk personel
            Indonesia, tetapi juga untuk negara-negara mitra di kawasan.
          </p>
        </div>

        {/* Key Initiatives */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Inisiatif Utama 2025</h2>
          <div className="space-y-6">
            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">🏆</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-3">
                    Training Recognition PBB
                  </h3>
                  <p className="text-base-content/70 mb-3">
                    Pelaksanaan Training Recognition oleh UN DPKO dan DFS pada
                    pertengahan 2025 untuk memberikan pengakuan resmi kemampuan
                    Polri dalam melaksanakan Pre-Deployment Training (PDT).
                  </p>
                  <div className="bg-primary/10 rounded-lg p-3">
                    <p className="text-sm text-base-content/70">
                      <strong>Manfaat:</strong> Sertifikasi resmi untuk
                      melaksanakan kursus PDT sesuai standar UN
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">🇻🇳</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-3">
                    Mobile Training Team Vietnam
                  </h3>
                  <p className="text-base-content/70 mb-3">
                    5 personel Polri sebagai Mobile Training Team (MTT)
                    memberikan pelatihan kepada Vietnam&apos;s Formed Police
                    Unit No.1 (VNFPU-1) di Hanoi, Vietnam (5-18 Mei 2025).
                  </p>
                  <div className="bg-secondary/10 rounded-lg p-3">
                    <p className="text-sm text-base-content/70">
                      <strong>Tujuan:</strong> Memperkuat kapasitas instruktur
                      Polri sebagai Regional Training Hub
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">👑</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-3">
                    IAPTC Executive Committee
                  </h3>
                  <p className="text-base-content/70 mb-3">
                    Kombes Pol FX. Arendra Wahyudi, S.I.K. ditunjuk sebagai
                    Police Chair di International Association of Peacekeeping
                    Training Centres (IAPTC) untuk 2 tahun ke depan.
                  </p>
                  <div className="bg-accent/10 rounded-lg p-3">
                    <p className="text-sm text-base-content/70">
                      <strong>Dampak:</strong> Memperkuat posisi Indonesia dalam
                      forum internasional peacekeeping
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="bg-base-200 rounded-xl p-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Content Section */}
            <div className="lg:w-2/3">
              <h2 className="text-2xl font-bold mb-6">Pencapaian dan Target</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-primary/10 rounded-lg p-6 text-center border-2 border-primary/20">
                  <div className="text-3xl mb-3">🎓</div>
                  <h3 className="font-semibold text-lg mb-2">
                    Training Recognition
                  </h3>
                  <p className="text-primary font-bold text-xl">2025</p>
                  <p className="text-sm text-base-content/70 mt-1">
                    Target Sertifikasi UN
                  </p>
                </div>

                <div className="bg-secondary/10 rounded-lg p-6 text-center border-2 border-secondary/20">
                  <div className="text-3xl mb-3">👨‍🏫</div>
                  <h3 className="font-semibold text-lg mb-2">MTT Deployment</h3>
                  <p className="text-secondary font-bold text-xl">5</p>
                  <p className="text-sm text-base-content/70 mt-1">
                    Personel ke Vietnam
                  </p>
                </div>

                <div className="bg-accent/10 rounded-lg p-6 text-center border-2 border-accent/20">
                  <div className="text-3xl mb-3">🌏</div>
                  <h3 className="font-semibold text-lg mb-2">Regional Hub</h3>
                  <p className="text-accent font-bold text-xl">ASEAN</p>
                  <p className="text-sm text-base-content/70 mt-1">
                    Training Center
                  </p>
                </div>

                <div className="bg-success/10 rounded-lg p-6 text-center border-2 border-success/20">
                  <div className="text-3xl mb-3">🏅</div>
                  <h3 className="font-semibold text-lg mb-2">IAPTC Position</h3>
                  <p className="text-success font-bold text-xl">Police Chair</p>
                  <p className="text-sm text-base-content/70 mt-1">
                    2 Tahun Mandate
                  </p>
                </div>
              </div>
            </div>

            {/* Images Section */}
            <div className="lg:w-1/3">
              <div className="bg-base-100 rounded-lg p-4">
                <h4 className="font-semibold mb-3 text-center">
                  Dokumentasi Program UN Capacity Building
                </h4>
                <div className="grid gap-3">
                  {/* UN Capacity Building images 0-3 */}
                  {[0, 1, 2, 3].map((imgNumber) => (
                    <div
                      key={imgNumber}
                      className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`}
                        alt={`UN Capacity Building dokumentasi ${imgNumber + 1}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            `/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const FacilitiesContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* Facilities Overview */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Fasilitas Pusat Misi Internasional Polri
          </h2>
          <p className="leading-relaxed text-base-content/70 mb-6">
            Pusat Misi Internasional Polri dilengkapi dengan fasilitas lengkap
            yang mendukung pelatihan, administrasi, dan penyelenggaraan program
            capacity building berkelas internasional.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {facilities.map((facility, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-4">
                <div className="flex items-center gap-3">
                  <div className="text-2xl">{facility.icon}</div>
                  <div className="flex-1">
                    <h3 className="font-medium text-sm leading-tight">
                      {facility.name}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Purposes */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Tujuan Pusat Misi Internasional
          </h2>
          <div className="space-y-4">
            {purposes.map((purpose, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="bg-primary rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-semibold text-sm">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-base-content/70 leading-relaxed">
                    {purpose}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Functions */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Fungsi Pusat Misi Internasional
          </h2>
          <div className="space-y-4">
            {functions.map((func, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <div className="bg-secondary rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-semibold text-sm">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-base-content/70 leading-relaxed">{func}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Instructor Certifications */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Content Section */}
            <div className="lg:w-2/3">
              <h2 className="text-2xl font-bold mb-6">
                Kualifikasi Instruktur
              </h2>
              <div className="bg-base-100 rounded-lg p-6">
                <p className="leading-relaxed text-base-content/70 mb-4">
                  Para pengajar/instruktur di Pusat Misi Internasional Polri
                  dilengkapi dengan berbagai sertifikat internasional untuk
                  memastikan kualitas pelatihan yang sesuai standar global.
                </p>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {[
                    { name: "UN", fullName: "United Nations" },
                    {
                      name: "CoESPU",
                      fullName:
                        "Center of Excellence for Stability Police Units",
                    },
                    {
                      name: "POTI",
                      fullName: "Peace Operations Training Institute",
                    },
                    { name: "RCMP", fullName: "Royal Canadian Mounted Police" },
                    {
                      name: "French Police",
                      fullName: "Police Nationale France",
                    },
                    { name: "Others", fullName: "Sertifikasi Lainnya" },
                  ].map((cert, index) => (
                    <div
                      key={index}
                      className="bg-base-200 rounded-lg p-3 text-center"
                    >
                      <h4 className="font-semibold text-sm mb-1">
                        {cert.name}
                      </h4>
                      <p className="text-xs text-base-content/70">
                        {cert.fullName}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Images Section */}
            <div className="lg:w-1/3">
              <div className="bg-base-100 rounded-lg p-4">
                <h4 className="font-semibold mb-3 text-center">
                  Fasilitas Pelatihan
                </h4>
                <div className="grid gap-3">
                  {/* UN Capacity Building images 4-7 */}
                  {[4, 5, 6, 7].map((imgNumber) => (
                    <div
                      key={imgNumber}
                      className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`}
                        alt={`Fasilitas pelatihan ${imgNumber - 3}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            `/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const ContributionsContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* Overview */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Kontribusi Polri dalam Organisasi Internasional
          </h2>
          <p className="leading-relaxed text-base-content/70">
            Kontribusi Kepolisian Republik Indonesia (Polri) dalam organisasi
            internasional cukup signifikan, terutama dalam bidang keamanan,
            penegakan hukum, dan kerja sama antar negara.
          </p>
        </div>

        {/* Contributions Details */}
        <div className="space-y-6">
          {internationalContributions.map((contribution, index) => (
            <div key={index} className="bg-base-200 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="text-3xl">{contribution.icon}</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg mb-3">
                    {contribution.title}
                  </h3>
                  <p className="text-base-content/70 leading-relaxed">
                    {contribution.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Regional Focus */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Fokus Kerjasama Regional</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">🇮🇩</span>
                ASEANAPOL
              </h3>
              <p className="text-base-content/70 mb-3">
                Polri aktif dalam ASEAN Police Cooperation dan ASEAN Chiefs of
                Police untuk memperkuat kerjasama keamanan regional.
              </p>
              <ul className="text-sm text-base-content/70 space-y-1">
                <li>• Pertukaran informasi intelijen</li>
                <li>• Penanggulangan kejahatan transnasional</li>
                <li>• Program pelatihan bersama</li>
              </ul>
            </div>

            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">🌏</span>
                East Asia Summit
              </h3>
              <p className="text-base-content/70 mb-3">
                Partisipasi dalam forum regional yang fokus pada kerjasama
                keamanan dan penegakan hukum di kawasan Asia Timur dan Asia
                Tenggara.
              </p>
              <ul className="text-sm text-base-content/70 space-y-1">
                <li>• Dialog keamanan multilateral</li>
                <li>• Capacity building regional</li>
                <li>• Kerjasama anti-terorisme</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Future Vision */}
        <div className="bg-gradient-to-r from-accent/20 to-success/20 rounded-xl p-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Content Section */}
            <div className="lg:w-2/3">
              <h2 className="text-2xl font-bold mb-6">Visi Masa Depan</h2>
              <div className="bg-base-100 rounded-lg p-6">
                <p className="leading-relaxed text-base-content/70 mb-4">
                  Polri berkomitmen untuk terus mengembangkan perannya sebagai
                  Regional Training Hub dan memperkuat kontribusi dalam
                  organisasi internasional untuk mendukung perdamaian dan
                  keamanan global.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-center">
                    <div className="text-2xl mb-2">📈</div>
                    <h4 className="font-semibold">Ekspansi Program</h4>
                    <p className="text-sm text-base-content/70">
                      Pengembangan program pelatihan baru
                    </p>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl mb-2">🤝</div>
                    <h4 className="font-semibold">Partnership</h4>
                    <p className="text-sm text-base-content/70">
                      Memperluas kemitraan internasional
                    </p>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl mb-2">🌟</div>
                    <h4 className="font-semibold">Excellence</h4>
                    <p className="text-sm text-base-content/70">
                      Meningkatkan standar kualitas
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Images Section */}
            <div className="lg:w-1/3">
              <div className="bg-base-100 rounded-lg p-4">
                <h4 className="font-semibold mb-3 text-center">
                  Aktivitas Internasional
                </h4>
                <div className="grid gap-3">
                  {/* UN Capacity Building images 8-11 */}
                  {[8, 9, 10, 11].map((imgNumber) => (
                    <div
                      key={imgNumber}
                      className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`}
                        alt={`Aktivitas internasional ${imgNumber - 7}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            `/gallery/un-capacity-building/UN Capacity Building_${imgNumber}.jpg`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Program Overview",
      icon: "🎯",
      component: <OverviewContent />,
    },
    {
      id: "facilities",
      label: "Fasilitas & Fungsi",
      icon: "🏢",
      component: <FacilitiesContent />,
    },
    {
      id: "contributions",
      label: "Kontribusi Global",
      icon: "🌍",
      component: <ContributionsContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="UN Capacity Building"
      subtitle="Pengembangan Kapasitas Misi Perdamaian PBB"
      icon="🎓"
      breadcrumbBase="Misi Internasional"
      tabs={tabs}
      footerTitle="UN Capacity Building Polri"
      footerDescription="Mengembangkan kapasitas pelatihan misi perdamaian PBB untuk mendukung Indonesia sebagai Regional Training Hub di kawasan Asia Tenggara."
      footerStats={[
        { label: "Training Recognition", value: "2025" },
        { label: "Regional Partners", value: "5+" },
        { label: "International Certs", value: "6+" },
      ]}
    />
  );
};

export default UNCapacityBuildingContent;
